import { EpiBlock } from '@api/types';

export const getFieldName = (block: EpiBlock) => `__field_${block?.contentLink?.id || ''}`;

export const isValidEmail = (email: string) => {
  const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
  return regex.test(email);
};
